import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

// ⬇️ Wolt sipariş linkini buradan değiştirebilirsin
const WOLT_ORDER_URL = 'https://order.site/cobarci/tr/deu/berlin/restaurant/corbaci-sf?no_universal_links=true';

const LABELS = {
  de: 'Bestellen mit',
  en: 'Order with',
  tr: 'Sipariş ver',
};

const WoltOrderButton = () => {
  const { language } = useLanguage();
  const label = LABELS[language] || LABELS.de;

  return (
    <a
      href={WOLT_ORDER_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="wolt-floating-order-button"
      className="fixed bottom-5 right-5 z-[60] group flex items-center gap-3 bg-[#00C2E8] hover:bg-[#00a9cc] text-white pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-[#00C2E8]/40 transition-all duration-300 transform hover:scale-105"
      style={{ boxShadow: '0 10px 30px rgba(0,194,232,0.45)' }}
    >
      <span className="absolute inset-0 rounded-full bg-[#00C2E8] animate-ping opacity-20 group-hover:opacity-0"></span>
      <span className="relative flex items-center justify-center w-9 h-9 bg-white rounded-full">
        <ShoppingBag className="w-5 h-5 text-[#00C2E8]" />
      </span>
      <span className="relative flex flex-col leading-tight">
        <span className="text-[11px] font-medium opacity-90" data-testid="wolt-button-label">{label}</span>
        <span className="text-lg font-extrabold tracking-tight -mt-0.5">Wolt</span>
      </span>
    </a>
  );
};

export default WoltOrderButton;
